import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import axiosInstance from "../../utils/axiosInstance";
import './scheduler.css';
import EventList from "./EventList";

const Scheduler = () => {
    const [eventName, setEventName] = useState('');
    const [eventDate, setEventDate] = useState('');
    const [repeat, setRepeat] = useState('none');
    const [events, setEvents] = useState([]);
    const [notifications, setNotifications] = useState([]);
    const [viewOption, setViewOption] = useState('today'); // 'all' or 'today'

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await axiosInstance.get('/events');
                setEvents(response.data.events);
            } catch (error) {
                addNotification('Error fetching events. Please try again.', 'danger');
                console.error('Error fetching events:', error);
            }
        };

        fetchEvents();
    }, []);

    const addNotification = (message, type) => {
        setNotifications([...notifications, { message, type }]);
    };

    const removeNotification = (index) => {
        setNotifications(notifications.filter((_, i) => i !== index));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const eventDateObj = new Date(eventDate);

        if (eventDateObj <= new Date()) {
            addNotification('Event date must be in the future.', 'danger');
            return;
        }

        try {
            const newEvent = {
                name: eventName,
                date: eventDateObj.toISOString(),
                repeat,
            };

            const response = await axiosInstance.post('/events', newEvent);
            setEvents([...events, response.data.event]);
            setEventName('');
            setEventDate('');
            setRepeat('none');
            addNotification('Event added successfully!', 'success');
        } catch (error) {
            addNotification('Error adding event. Please try again.', 'danger');
        }
    };

    const handleDelete = async (id) => {
        try {
            await axiosInstance.delete(`/events/${id}`);
            setEvents(events.filter(event => event._id !== id));
            addNotification('Event deleted successfully!', 'success');
        } catch (error) {
            addNotification('Error deleting event. Please try again.', 'danger');
        }
    };

    const formatDate = (date) => {
        return `${new Date(date).toLocaleDateString()} ${new Date(date).toLocaleTimeString()}`;
    };

    return (
        <Container>
            <Row className="justify-content-center my-4">
                <Col xs={12} md={8} lg={6}>
                    <Form onSubmit={handleSubmit} className="event-form">
                        <Form.Group controlId="eventName" >
                            <Form.Control
                                type="text"
                                placeholder="Enter event name"
                                value={eventName}
                                onChange={(e) => setEventName(e.target.value)}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="eventDate" className="my-3">
                            <Form.Control
                                type="datetime-local"
                                value={eventDate}
                                onChange={(e) => setEventDate(e.target.value)}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="repeat">
                            <Form.Control
                                as="select"
                                value={repeat}
                                onChange={(e) => setRepeat(e.target.value)}
                            >
                                <option value="none">None</option>
                                <option value="daily">Daily</option>
                                <option value="weekly">Weekly</option>
                                <option value="yearly">Yearly</option>
                            </Form.Control>
                        </Form.Group>

                        <Button variant="primary" type="submit" className="submit-button my-4">
                            Add Event
                        </Button>
                    </Form>
                </Col>
            </Row>

            <Row className="justify-content-center my-4">
                <Col xs={12} md={8} lg={6}>
                    <div className="d-flex justify-content-between mb-3">
                        <Button
                            variant={viewOption === 'today' ? 'info' : 'outline-info'}
                            onClick={() => setViewOption('today')}
                        >
                            Today's Events
                        </Button>
                        <Button
                            variant={viewOption === 'all' ? 'info' : 'outline-info'}
                            onClick={() => setViewOption('all')}
                        >
                            All Events
                        </Button>
                    </div>
                    <EventList events={events} handleDelete={handleDelete} viewOption={viewOption} />
                </Col>
            </Row>
        </Container>
    );
};

export default Scheduler;
